export default {
  name: "FooterSection",
  data(){
    return({
      rights:{
        company_name: "Department of Basic Education",
        year: new Date().getFullYear()
      }
    })
  }
};
